import { useState } from 'react'
import adminFetch from './adminFetch'


// One shared helper now: see admin/adminFetch for why three copies of this
// was the bug, not just duplication.
const apiFetch = adminFetch

const inputStyle = {
  width: '100%', background: '#0d1117', border: '1px solid #374151',
  borderRadius: 8, color: '#f1f5f9', padding: '10px 12px',
  fontSize: 14, outline: 'none', boxSizing: 'border-box',
}

const labelStyle = {
  fontSize: 11, fontWeight: 700, color: '#4b5563',
  textTransform: 'uppercase', letterSpacing: '.06em',
  display: 'block', marginBottom: 8,
}

export default function AdminPaymentLink({ shop, token, onClose }) {
  const [chargeName, setChargeName] = useState(`SyncE Bridge Subscription`)
  const [price,      setPrice]      = useState('')
  const [interval,   setInterval]   = useState('monthly')
  const [trialDays,  setTrialDays]  = useState('7')
  const [isTest,     setIsTest]     = useState(true)
  const [creating,   setCreating]   = useState(false)
  const [result,        setResult]        = useState(null)
  const [error,         setError]         = useState('')
  const [copied,        setCopied]        = useState(false)

  async function createLink() {
    setError('')
    if (!chargeName.trim())          return setError('Charge name is required')
    const priceNum = parseFloat(price)
    if (!price || isNaN(priceNum) || priceNum <= 0) return setError('Enter a valid price greater than 0')

    setCreating(true)
    try {
      const data = await apiFetch(`/shops/${shop.id}/payment-link`, token, {
        method: 'POST',
        body: {
          chargeName: chargeName.trim(),
          price: priceNum,
          interval,
          trialDays: parseInt(trialDays) || 0,
          isTest,
        },
      })
      if (data.error) { setError(data.error); return }
      setResult(data)
    } catch (e) {
      setError(e.message)
    } finally { setCreating(false) }
  }

  function copyLink() {
    navigator.clipboard.writeText(result.confirmationUrl).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <>
      <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:300 }}/>
      <div style={{
        position:'fixed', right:0, top:0, bottom:0, width:480,
        background:'#111827', borderLeft:'1px solid #1f2937',
        zIndex:301, display:'flex', flexDirection:'column',
        boxShadow:'-8px 0 40px rgba(0,0,0,0.5)',
      }}>
        {/* Header */}
        <div style={{ padding:'20px 24px', borderBottom:'1px solid #1f2937', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
          <div>
            <div style={{ fontSize:15, fontWeight:700 }}>Create Subscription Link</div>
            <div style={{ fontSize:11, color:'#6b7280' }}>{shop.shopify_domain}</div>
          </div>
          <button onClick={onClose} style={{ background:'#1f2937', border:'1px solid #374151', borderRadius:8, color:'#9ca3af', padding:'8px 12px', fontSize:14, cursor:'pointer' }}>✕</button>
        </div>

        <div style={{ flex:1, overflowY:'auto', padding:'24px' }}>
          {!result ? <>
            {/* Current plan info */}
            {shop.plan_name && (
              <div style={{ background:'rgba(79,142,247,0.08)', border:'1px solid rgba(79,142,247,0.2)', borderRadius:10, padding:'12px 14px', marginBottom:20 }}>
                <div style={{ fontSize:12, color:'#4f8ef7', fontWeight:600 }}>
                  Current plan: {shop.plan_name} · {shop.charge_status || 'unknown status'}
                </div>
              </div>
            )}

            {/* Charge name */}
            <div style={{ marginBottom:18 }}>
              <label style={labelStyle}>Charge Name</label>
              <input
                value={chargeName}
                onChange={e => setChargeName(e.target.value)}
                placeholder="e.g. SyncE Bridge Pro Plan"
                style={inputStyle}
              />
              <div style={{ fontSize:11, color:'#4b5563', marginTop:5 }}>This is what appears on the seller's Shopify billing page.</div>
            </div>

            {/* Price + interval row */}
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:18 }}>
              <div>
                <label style={labelStyle}>Price (USD)</label>
                <div style={{ position:'relative' }}>
                  <span style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'#6b7280', fontSize:14 }}>$</span>
                  <input
                    type="number"
                    min="0.01"
                    step="0.01"
                    value={price}
                    onChange={e => setPrice(e.target.value)}
                    placeholder="0.00"
                    style={{ ...inputStyle, paddingLeft:26 }}
                  />
                </div>
              </div>
              <div>
                <label style={labelStyle}>Billing Interval</label>
                <div style={{ display:'flex', gap:6 }}>
                  {['monthly', 'yearly'].map(iv => (
                    <button key={iv} onClick={() => setInterval(iv)} style={{
                      flex:1, padding:'10px 0', borderRadius:8, border:'none', cursor:'pointer',
                      fontSize:12, fontWeight:600, textTransform:'capitalize',
                      background: interval === iv ? '#0064d2' : '#1f2937',
                      color: interval === iv ? '#fff' : '#9ca3af',
                    }}>{iv === 'monthly' ? 'Monthly' : 'Yearly'}</button>
                  ))}
                </div>
              </div>
            </div>

            {/* Trial days */}
            <div style={{ marginBottom:24 }}>
              <label style={labelStyle}>Trial Days</label>
              <input
                type="number"
                min="0"
                max="90"
                value={trialDays}
                onChange={e => setTrialDays(e.target.value)}
                placeholder="0"
                style={{ ...inputStyle, width:120 }}
              />
              <div style={{ fontSize:11, color:'#4b5563', marginTop:5 }}>Set to 0 for no trial period.</div>
            </div>

            {/* Test / Live toggle */}
            <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:24 }}>
              <div onClick={() => setIsTest(!isTest)} style={{
                width:44, height:24, borderRadius:12, cursor:'pointer', position:'relative',
                background: isTest ? '#374151' : '#0064d2', transition:'background .2s',
              }}>
                <div style={{
                  position:'absolute', top:3, width:18, height:18, borderRadius:'50%', background:'#fff',
                  left: isTest ? 3 : 23, transition:'left .2s',
                }}/>
              </div>
              <div>
                <div style={{ fontSize:13, fontWeight:600, color: isTest ? '#9ca3af' : '#0064d2' }}>
                  {isTest ? 'Test charge' : 'Live charge'}
                </div>
                <div style={{ fontSize:11, color:'#4b5563' }}>
                  {isTest ? 'Use for development stores — no real money charged.' : 'Real billing — use on production stores only.'}
                </div>
              </div>
            </div>

            {/* Summary preview */}
            {price && parseFloat(price) > 0 && (
              <div style={{ background:'rgba(0,100,210,0.06)', border:'1px solid rgba(0,100,210,0.2)', borderRadius:10, padding:'14px 16px', marginBottom:20 }}>
                <div style={{ fontSize:12, color:'#0064d2', fontWeight:700, marginBottom:4 }}>Summary</div>
                <div style={{ fontSize:13, color:'#f1f5f9' }}>
                  <strong>{chargeName || '—'}</strong>
                </div>
                <div style={{ fontSize:12, color:'#9ca3af', marginTop:4 }}>
                  ${parseFloat(price).toFixed(2)} / {interval} · {parseInt(trialDays) > 0 ? `${trialDays}-day trial` : 'No trial'}
                </div>
              </div>
            )}

            {error && <div style={{ fontSize:12, color:'#f25d5d', marginBottom:12 }}>{error}</div>}

            <button onClick={createLink} disabled={creating} style={{
              width:'100%', padding:'13px',
              background: creating ? '#374151' : 'linear-gradient(135deg, #0064d2, #e53238)',
              border:'none', borderRadius:10, color:'#fff',
              fontSize:14, fontWeight:700, cursor: creating ? 'not-allowed' : 'pointer',
            }}>
              {creating ? 'Generating…' : 'Generate Subscription Link'}
            </button>

            <div style={{ fontSize:11, color:'#4b5563', textAlign:'center', marginTop:10 }}>
              Share this link with the seller. They approve the charge from their Shopify account.
            </div>
          </> : (
            /* Result */
            <div>
              <div style={{ background:'rgba(52,201,126,0.08)', border:'1px solid rgba(52,201,126,0.2)', borderRadius:12, padding:'20px', marginBottom:20 }}>
                <div style={{ fontSize:13, fontWeight:700, color:'#34c97e', marginBottom:4 }}>✓ Subscription link generated</div>
                <div style={{ fontSize:12, color:'#6b7280', marginBottom:12 }}>
                  {result.chargeName} · ${result.price}/{result.interval === 'yearly' ? 'yr' : 'mo'}
                  {result.trialDays > 0 ? ` · ${result.trialDays}-day trial` : ''}
                </div>
                <div style={{ fontSize:11, color:'#4b5563', wordBreak:'break-all', background:'#0d1117', padding:'10px 12px', borderRadius:8, marginBottom:14, fontFamily:'monospace' }}>
                  {result.confirmationUrl}
                </div>
                <div style={{ display:'flex', gap:8 }}>
                  <button onClick={copyLink} style={{
                    background: copied ? 'rgba(52,201,126,0.15)' : 'linear-gradient(135deg,#0064d2,#f5a623)',
                    border: copied ? '1px solid rgba(52,201,126,0.3)' : 'none',
                    borderRadius:8, color: copied ? '#34c97e' : '#fff',
                    padding:'9px 18px', fontSize:13, fontWeight:700, cursor:'pointer', flex:1,
                  }}>
                    {copied ? '✓ Copied!' : 'Copy Link'}
                  </button>
                  <button onClick={() => window.open(result.confirmationUrl, '_blank')} style={{
                    background:'#1f2937', border:'1px solid #374151',
                    borderRadius:8, color:'#9ca3af', padding:'9px 18px',
                    fontSize:13, fontWeight:700, cursor:'pointer',
                  }}>Open ↗</button>
                </div>
              </div>
              <button onClick={() => { setResult(null); setError('') }} style={{
                width:'100%', padding:'10px', background:'#1f2937',
                border:'1px solid #374151', borderRadius:8,
                color:'#9ca3af', fontSize:13, fontWeight:600, cursor:'pointer',
              }}>Generate Another Link</button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
